import { useRouteLoaderData } from "react-router";
import * as v from "valibot";
import type { loader as rootLoader } from "~/root";

const getBytescaleSchema = () =>
  v.object({
    accountId: v.string(),
    folderPath: v.object({
      media: v.string(),
      public: v.string(),
    }),
    publicKey: v.string(),
  });

export function useOptionalBytescaleConfig() {
  const data = useRouteLoaderData<typeof rootLoader>("root");

  if (
    !data ||
    !("bytescale" in data) ||
    !v.parse(getBytescaleSchema(), data.bytescale)
  )
    return undefined;

  return data.bytescale;
}

export function useBytescaleConfig() {
  const bytescale = useOptionalBytescaleConfig();

  if (!bytescale) {
    throw new Error(
      "No bytescale found in root loader, but bytescale is required by `useBytescaleConfig`. If use is optional try `useOptionalBytescaleConfig` instead.",
    );
  }

  return bytescale;
}
